App.controller('RemindCtrl', ['$scope', '$sce', '$state', '$http', 'authService', '$mdDialog', 'Config', 'popUpService', '$rootScope',
    function ($scope, $sce, $state, $http, authService, $mdDialog, Config, popUpService, $rootScope) {
    $scope.remind = function() {
    	var vm = this;

        if (!vm.form.$valid) {
            $scope.showPopUp('', 'Błąd formularza', 'Sprawdź czy wszystkie pola zostały wypełnione prawidłowo');
            return 0;
        }

        var authPrefix = $rootScope.CONFIGURATOR.authPrefix;
        var originURL  = authPrefix.substring(0, authPrefix.length -1);


        var data = {
            identifier: $scope.identifier,
            origin: originURL,
            recaptchaResponse: $scope.recaptchaResponse
        };

        authService.remind(data).then(function (data) {
            if (data.status === 200) {
            	$scope.identifier = '';
            	vm.form.$setPristine();
                vm.form.$setUntouched();
                vm.form.$submitted = false;

                $scope.showPopUp('', 'Sprawdź swoją pocztę', 'Na adres e-mail podany w trakcie rejestracji została wysłana wiadomość z linkiem do zmiany hasła.');
            } else {
                if (data.data.message === 'UserNotExistsException') {
                    popUpService.showPopUpWithError(data.data, {ev: '', head: 'Nieprawidłowy PESEL/Numer paszportu', content: 'Nie znależliśmy podanego identyfikatora w bazie, spróbuj ponownie.'});
                } else {
                    popUpService.showPopUpWithError(data.data, {head:'Wystąpił błąd', content:'Skontaktuj się z administratorem lub spróbuj ponownie.'});
                }
            }
        });
    };

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.confirm = function () {
            $mdDialog.hide($scope.locals);
        };
    }
    PopUpInfoCtrl.$inject = ['$scope', '$mdDialog', 'locals'];
    $scope.showPopUp = function(ev, head, content) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                head: head,
                content: content
            }
        }).then(function(data) {

        }, function() {

        });
    };
}]);
